import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ContainerTypeService } from '../../core/services/container-type.service';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ContainerTypeFormBaseComponent } from '../container-type-form-base.component';

@Component({
  selector: 'app-container-type-update',
  templateUrl: './container-type-update.component.html',
  styleUrls: ['./container-type-update.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
})
export class ContainerTypeUpdateComponent extends ContainerTypeFormBaseComponent implements OnInit {
  containerTypeId: number | null = null;

  constructor(
    protected override fb: FormBuilder,
    private route: ActivatedRoute,
    private containerTypeService: ContainerTypeService,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id !== null) {
      this.containerTypeId = +id;
      this.loadContainerType();
    }
  }

  loadContainerType(): void {
    if (this.containerTypeId !== null) {
      this.containerTypeService.getContainerType(this.containerTypeId).subscribe({
        next: containerType => {
          this.containerTypeForm.patchValue(containerType);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al cargar el tipo de contenedor:', error.message);
          this.errorMessage =
            error.error.message || 'Ocurrió un error al cargar el tipo de contenedor';
        },
      });
    }
  }

  onSubmit(): void {
    if (this.containerTypeForm.valid && this.containerTypeId !== null) {
      this.containerTypeService
        .updateContainerType(this.containerTypeId, this.containerTypeForm.value)
        .subscribe({
          next: response => {
            console.log('Tipo de contenedor actualizado:', response);
            this.router.navigate(['/container-types']);
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error al actualizar el tipo de contenedor:', error.message);
            this.errorMessage =
              error.error || 'Ocurrió un error al actualizar el tipo de contenedor';
          },
          complete: () => {
            console.log('Solicitud de actualización de tipo de contenedor completada');
          },
        });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
